export default __webpack_public_path__ + "static/media/P102.1.2741ac02.mp3";